<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="col-form-label control-label">{{
            $t('user.underSubProgram')
          }}</label>
          <div id="sub-group" class="ts-border ts-border-gray-300 ts-rounded">
            <ul class="ts-reset ts-px-4 ts-py-2 ts-h-full">
              <li v-for="sub in sub_programs" :key="sub.acps_id">
                <ts-checkbox
                  v-model="model.sub_programs"
                  :value="sub.acps_id"
                  >{{ sub.acps_name_foreign }}</ts-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'subProgramComponent',
  props: ['value'],
  data() {
    return {
      loading: false,
      sub_programs: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchSubProgram()
  },
  methods: {
    fetchSubProgram() {
      this.loading = true
      this.$store
        .dispatch('user/getSubProgram')
        .then(response => {
          this.sub_programs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
#sub-group {
  min-height: 80px;
  max-height: 100px;
  overflow-y: scroll;
}
</style>
